module.exports = {
	toggle: function() {
		$('.sidebar').toggleClass('in');
		$('button.toggle-sidebar').toggleClass('active');
	}
};



// WEBPACK FOOTER //
// ./frontend/shared/js/lib/sidebar.js